import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useRef, type CSSProperties } from 'react';
import { useResizeObserver } from '../../../hooks';
function getHeightFromStyleGetter(styleHeight: string | number | undefined) {
  return () => typeof styleHeight === 'number' ? styleHeight : typeof styleHeight === 'string' ? parseFloat(styleHeight) : null;
}
function useHeightObserver(t0) {
  const $ = _c(8);
  const {
    style,
    onChangeSize
  } = t0;
  style?.height;
  const t1 = style?.height;
  let t2;
  if ($[0] !== t1) {
    t2 = getHeightFromStyleGetter(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getHeightFromStyle = t2;
  const localRef = useRef(null);
  let t3;
  if ($[2] !== getHeightFromStyle) {
    t3 = getHeightFromStyle();
    $[2] = getHeightFromStyle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const heightRef = useRef(t3);
  let t4;
  if ($[4] !== onChangeSize) {
    t4 = height => {
      if (!onChangeSize || !height) {
        return;
      }
      const roundedHeight = Math.round(height);
      if (typeof heightRef.current === "number" && heightRef.current > 0 && roundedHeight !== heightRef.current) {
        onChangeSize(roundedHeight);
        heightRef.current = roundedHeight;
      }
    };
    $[4] = onChangeSize;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleSizeChange = t4;
  let t5;
  if ($[6] !== handleSizeChange) {
    t5 = {
      ref: localRef,
      box: "border-box",
      onResize: t6 => {
        const {
          height: height_0
        } = t6;
        return handleSizeChange(height_0);
      }
    };
    $[6] = handleSizeChange;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useResizeObserver(t5);
  return localRef;
}
export default useHeightObserver;